/**
 * Created by Andrey Popov on 07.08.26
 */

cleverapps.override(cleverapps.EVENTS, {
    INVITE_FRIENDS_SHOWN: "invite_friends_shown",
    INVITE_FRIENDS_CONGRAT: "invite_friends_congrat",
    INVITE_FRIENDS_CLICK: "invite_friends_click",
    INVITE_FRIENDS_SENT: "invite_friends_sent",
    INVITE_FRIENDS_ARRIVE: "invite_friends_arrive",
    INVITE_FRIENDS_JOINED: "invite_friends_joined",
    INVITE_FRIENDS_REWARD: "invite_friends_reward",
    INVITE_FRIENDS_DISMISS: "invite_friends_dismiss"
});

cleverapps.override(cleverapps.EVENTS.EARN, {
    INVITE_FRIENDS: "invite_friends"
});
